<!-- CP連携ページの場合 -->
<app-doctors-next-login-connect-cportal *ngIf="flagment" [password]="password">
</app-doctors-next-login-connect-cportal>

<!-- 通常ログインの場合 -->
<div *ngIf="!flagment" id="wrapper" class="h-100vh p-3">
  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column ml-0">
    <!-- Main Content -->
    <div id="content">
      <div class="container-fluid">
        <div class="row logo">
          <div class="col-12 row no-gutters justify-content-center">
            <h1
              class="d-flex justify-content-center"
              style="flex-direction: column; align-items: center"
            >
              <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
            </h1>
          </div>
        </div>

        <div class="row" style="letter-spacing: 0">
          <form
            id="login_form"
            (submit)="_login()"
            class="col-12 user-form-login mx-auto center-block mt-5"
          >
            <input
              type="hidden"
              name="_token"
              value="6BzPhkuZvgcmeaxHiYrrzfhW46QMCC5m4Eva1ygU"
            />
            <div
              *ngIf="errorMessages.login.password"
              class="row no-gutters mx-auto error-message"
            >
              <div class="col-md-12 col-12">
                <div class="alert alert-danger" role="alert">
                  正しいメールアドレスまたはパスワードを入力してください。
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group justify-content-center">
                <label
                  class="col-form-label mb-0 py-0"
                  for="email"
                  style="font-weight: bold; font-size: 16px !important"
                  >メールアドレス</label
                >
              </div>
              <div class="input-group justify-content-center">
                <input
                  [(ngModel)]="email"
                  type="text"
                  class="form-control"
                  id="email"
                  name="email"
                  placeholder="メールアドレス"
                  value=""
                  autofocus=""
                  aria-describedby="email-help"
                />
              </div>
            </div>

            <div class="form-group">
              <div class="input-group justify-content-center">
                <label
                  for="password"
                  class="col-form-label py-0"
                  style="font-weight: bold; font-size: 16px !important"
                  >パスワード</label
                >
              </div>
              <div class="input-group justify-content-center">
                <input
                  [(ngModel)]="password"
                  type="password"
                  class="form-control"
                  id="password"
                  name="password"
                  placeholder="パスワード"
                />
              </div>
            </div>

            <div>
              <div class="col-md-12 col-12 text-center">
                <a
                  (click)="navigate('forgot-password')"
                  style="font-size: 16px; font-weight: normal; cursor: pointer"
                  >パスワードを忘れた方</a
                ><br />
                <button type="submit" class="btn my-3">ログイン</button>
              </div>
            </div>

            <div class="row no-gutters justify-content-center pb-2 pt-2">
              <div
                class="custom-control custom-checkbox custom-control-lg remember-email"
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="remember-email"
                  name="remember-email"
                  [(ngModel)]="isSaveEmail"
                />
                <label
                  class="custom-control-label pl-1"
                  for="remember-email"
                  style="font-size: 16px; font-weight: normal"
                >
                  メールアドレスを保存する
                </label>
              </div>
            </div>

            <div>
              <div class="col-md-12 col-12 text-center">
                <button
                  style="background-color: rgba(0, 0, 0, 0)"
                  type="button"
                  (click)="navigate('register')"
                  class="btn btn-outline my-3 align-items-center"
                  id="register_doctor_btn"
                >
                  新規登録</button
                ><br />

                <a
                  href="https://doctors-inc.jp/contact/"
                  target="_blank"
                  style="font-size: 16px; font-weight: normal"
                  >お問い合わせはこちら</a
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
